import { ca } from '@cian/analytics';
import get from 'lodash/get';

import validation from '../../../scripts/services/validation';
import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';
import { isFakeEmail } from '../../../../../shared/utils/email';

export default [
  '$scope', '$uibModalInstance', 'popupService', 'reportService', '$rootScope', 'ad', 'geoService', 'deviceService',
  function (
    $scope, $uibModalInstance, popupService, reportService, $rootScope, ad, geoService, deviceService,
  )
{
  $scope.isMobile = deviceService.isMobile;
  // Делаем копию объявления, чтобы изменения данных в попапе не влияли на данные обяъявления
  const userInput = get(ad, 'geo.userInput');
  const coordinates = geoService.getCoordinates();

  $scope.email = $rootScope.user.email && !isFakeEmail($rootScope.user.email)
    ? $rootScope.user.email
    : '';

  $scope.geo = {
    address: userInput,
    coordinates,
    zoom: 16,
  };

  $scope.isDisplayHint = true;

  /**
   * Вернёт false или текст ошибки
   */
  const fileSizeValidator = (file) => {
    const MAX_FILE_SIZE = 10; // megabytes
    const sizeInMegaBytes = file.size / 1000000;
    const isInvalid = sizeInMegaBytes > MAX_FILE_SIZE;

    return isInvalid && 'Ошибка. Размер файла превышает 10 МБ';
  };

  /**
   * Вернёт false или текст ошибки
   */
  const fileTypeValidator = (file) => {
    const isInvalid = !['image/jpeg', 'image/png', 'image/gif', 'application/pdf'].includes(file.type);

    return isInvalid && 'Ошибка. Файл должен быть в формате jpg, png, pdf или gif';
  };

  const isFileInvalid = (file) => {
    // Собираем массив с текстами ошибок
    let errors = [
      fileSizeValidator(file),
      fileTypeValidator(file),
    ].filter(Boolean);

    $scope.attachmentInvalid = errors.length ? errors : null;

    return $scope.attachmentInvalid;
  };

  $scope.selectFile = ({ target: {files} }) => {
    if (!files[0]) {
      return;
    }

    const file = files[0];

    if (isFileInvalid(file)) {
      return;
    }

    const fileReader = new FileReader();

    fileReader.onloadend = (e) => {
      // Разбиваем data:URI на подстроки. Элемент с индексом 1 — содержимое файла в base64.
      const data = e.target.result.split('base64,');

      $scope.attachment = {
        content: data[1],
        filename: file.name,
        mimeType: file.type,
      };

      $scope.$apply();
    }

    fileReader.readAsDataURL(file);
  };

  $scope.removeFile = () => {
    $scope.attachment = undefined;
  };

  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.sendReport = () => {
    ca('event', {
      name: 'oldevent',
      category: adAnalyticsCategory,
      action: 'AddressIssuesPopupSend',
      label: ''
    });

    $scope.form.$setSubmitted();

    if ($scope.form.$invalid) {
      return;
    }

    const {
      text,
      attachment,
      geo: {
        address, coordinates: { lat, lng }, zoom,
      },
    } = $scope;

    const email = $scope.form['email'].$viewValue;

    const coordinatesString = encodeURIComponent(`${lat} ${lng}`);

    reportService.sendAddressProblem({
      attachment: attachment || null,
      email,
      text,
      address,
      link: `https://yandex.ru/maps/?text=${coordinatesString}&z=${zoom}`,
    })
      .then(() => {
        $uibModalInstance.dismiss('sent');

        if (deviceService.isMobile) {
          $uibModalInstance.closed.then(() => {
            popupService.openPopup('reportMessageOk');
          });
        } else {
          popupService.openPopup('reportMessageOk');
        }
      })
      .catch(() => {
        $uibModalInstance.dismiss('error');

        if (deviceService.isMobile) {
          $uibModalInstance.closed.then(() => {
            popupService.openPopup('reportMessageError');
          });
        } else {
          popupService.openPopup('reportMessageError');
        }
      });
  };

  $scope.$watch('form', () => {
    $scope.validationEmail = validation($scope.form, 'email', {
      required: 'Введите email',
      email: 'Введите корректный email',
    });

    $scope.validationMessage = validation($scope.form, 'text', {
      required: 'Укажите проблему',
    });
  });

  $scope.$on('modal.closing', (_, type) => {
    if (type === 'cancel') {
      ca('event', {
        name: 'oldevent',
        category: adAnalyticsCategory,
        action: 'AddressIssuesPopupCancel',
        label: ''
      });
    } else {
      ca('event', {
        name: 'oldevent',
        category: adAnalyticsCategory,
        action: 'AddressIssuesPopupClose',
        label: ''
      });
    }
  });
}];
